// /welcomeday — the public Welcome Day orientation viewer.
//
// Mounts the ported WelcomeDay app full-screen against the same static
// pathfinder snapshot the campus pathfinder uses (public/Map Info/pathfinder/).
// Itinerary + places come from /api/welcome-day; images from public + Blob.

import { useEffect } from 'react';
import WelcomeDay from './welcomeday/WelcomeDay.jsx';
import { createHttpDataSource } from './pathfinder/lib/dataSource.js';

const MAPS_KEY = process.env.REACT_APP_MAPS_KEY;

// The "Map Info" folder has a space — it MUST be percent-encoded (%20) or
// Safari's fetch() rejects the URL. (Same note as PathfinderPage.)
const dataSource = createHttpDataSource('/Map%20Info/pathfinder/');

export default function WelcomeDayPage() {
  // Best-effort portrait lock for installed PWAs / Android Chrome (iOS ignores).
  useEffect(() => {
    try { window.screen?.orientation?.lock?.('portrait').catch(() => {}); } catch { /* unsupported */ }
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0 }}>
      <WelcomeDay dataSource={dataSource} apiKey={MAPS_KEY} />
    </div>
  );
}
